export default {
  button: {
    float: "right",
  },
};



// WEBPACK FOOTER //
// ./src/views/user/agenda/Agenda.styles.js